<template>
    <div class="echarts" ref="echart"/>
</template>

<script>

export default {
    props: {
        options: Object
    },
    data() {
        return {
            echart: null
        };
    },
    watch: {
        options: {
            handler(val, oldVal) {
                if (this.echart) {
                    // mutating `options` will lead to merging
                    // replacing it with new reference will lead to not merging
                    // eg.
                    // `this.options = Object.assign({}, this.options, { ... })`
                    // will trigger `this.chart.setOption(val, true)
                    // `this.options.title.text = 'Trends'`
                    // will trigger `this.chart.setOption(val, false)`
                    this.echart.setOption(this.options, val !== oldVal);
                }
            },
            deep: true
        }
    },
    methods: {
        async renderChart() {
            if (this.options) {
                // laod echarts lazily
                const [echarts] = await Promise.all([
                    import(/* webpackChunkName: "echarts" */ 'echarts/lib/echarts'),
                    import(/* webpackChunkName: "echarts" */'echarts/lib/chart/line'),
                    import(/* webpackChunkName: "echarts" */'echarts/lib/component/tooltip'),
                    import(/* webpackChunkName: "echarts" */'echarts/lib/component/title'),
                    import(/* webpackChunkName: "echarts" */'echarts/lib/component/legend'),
                    import(/* webpackChunkName: "echarts" */'echarts/lib/component/dataZoom')
                ]);

                this.echart = echarts.init(this.$refs.echart);
                this.echart.setOption(this.options);
            }
        }
    },
    mounted() {
        this.renderChart();
    },
    beforeDestroy() {
        if (this.echart) {
            this.echart.dispose();
            this.echart = null;
        }
    }
};
</script>

<style lang="less">
.echarts {
  width: 600px;
  height: 400px;
}
</style>

